export const colors = {
  white: '#fff',
  grey: '#f1f4f5',
  greyButton: '#f8f9fa',
  greyDarker: '#eef2f7',
  greyDarkest: '#c0ccce',

  textGrey: '#757c85',
  textGreyDarker: '#575757',

  danger: '#FA4A4D',
  dangerDarker: '#d81c1c',

  primary: '#394892',
  primaryLighter: '#808CC5',
  primaryLight: '#5463A7',
  primaryDark: '#23337D',
  primaryDarker: '#122063',

  darkGrey: '#848484',
  green: '#1FCECA',
  defaultShadow: '0 1px 3px rgba(0, 0, 0, 0.16)',
  defaultBorder: '1px solid #E8E8E8',
  disabled: '#BDC3C7'
}

